module.exports = __webpack_public_path__ + "img/hp-h4.1d0bc900.svg";